



















import { computed, defineComponent } from "@vue/composition-api";
import { UserVerificationStatus } from "@scrile/api-provider/dist/api/UserVerificationProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { getProfileUrl } from "@/lib/urlHelpers";
import { UserWithVerificationStatus } from "@/types";
import AvatarDescription from "@/components/AvatarDescription";
import BaseIcon from "@/components/BaseIcon";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "MoreMenuUser",
  components: { AvatarDescription, BaseSpinner, BaseIcon },
  setup() {
    const { authUser, userVerificationStatus } = useAuthUser();
    const profileUrl = computed(() => getProfileUrl(authUser.value ? authUser.value : ""));
    const user = computed<UserWithVerificationStatus | null>(() =>
      authUser.value
        ? {
            ...authUser.value,
            verified: userVerificationStatus.value === UserVerificationStatus.VERIFIED,
            disabled: !!authUser.value?.accountInfo.disabled,
          }
        : null
    );

    return {
      profileUrl,
      authUser,
      user,
    };
  },
});
